import React, { FC } from 'react';
import Section from 'evcharging/containers/layout/Section';
import Container from 'evcharging/components/Container';
import Title from 'evcharging/components/Title';
import FindProgramAccordion from 'evcharging/containers/ev-rebates/FindProgramAccordion';
import Spacer from 'evcharging/components/Spacer';
import { FindProgramAccordionItemProps } from 'evcharging/containers/ev-rebates/FindProgramAccordionItem';
import useI18n from 'evcharging/hooks/useI18n';

interface FindProgramProps {
  rebates: FindProgramAccordionItemProps[];
}

const FindProgram: FC<FindProgramProps> = (props) => {
  const { rebates } = props;
  const { t } = useI18n();

  return (
    <Section background={'middle'}>
      <Container>
        <Title center maxWidth={1100} variant={'h2'}>
          {t('rebates.program.title')}
        </Title>
        <Spacer value={12} mobile={0} />
        <FindProgramAccordion items={rebates} />
      </Container>
    </Section>
  );
};

export default FindProgram;
